import { createContext, useContext } from "react";
import CommonStore from "./commonStore";
import ModalStore from "./modalStore";
import ResidentStore from "./residentStore";

interface Store {
    commonStore: CommonStore;
    modalStore: ModalStore;   
    residentStore: ResidentStore;
}

export const store: Store = {
    commonStore: new CommonStore(), 
    modalStore: new ModalStore(),
    residentStore: new ResidentStore()
}

export const StoreContext = createContext(store);

export function useStore() {
    return useContext(StoreContext);
}